import { useState, useEffect, useRef, useCallback } from 'react';
import DoramaCard from '../components/DoramaCard';
import SkeletonCard from '../components/SkeletonCard';
import { useGetMaterialsQuery } from '../services/materialsApi';
import styles from '../css/Catalog.module.css';

const New = () => {
  const [page, setPage] = useState(1);
  const [allDramas, setAllDramas] = useState([]);
  const sentinelRef = useRef(null);

  const { data, isFetching } = useGetMaterialsQuery({
    year: 2026,
    sort_by: 'imdb_rating',
    sort_order: 'desc',
    per_page: 24,
    page,
  });

  useEffect(() => {
    if (data?.data) {
      setAllDramas(prev => {
        const existingIds = new Set(prev.map(d => d.id));
        const newItems = data.data.filter(d => !existingIds.has(d.id));
        return [...prev, ...newItems];
      });
    }
  }, [data]);

  const totalCount = data?.meta?.total ?? 0;
  const totalPages = data?.meta?.total_pages ?? 1;
  const hasMore = page < totalPages;

  const handleObserver = useCallback((entries) => {
    const [entry] = entries;
    if (entry.isIntersecting && !isFetching && hasMore) {
      setPage(p => p + 1);
    }
  }, [isFetching, hasMore]);

  useEffect(() => {
    const observer = new IntersectionObserver(handleObserver, { threshold: 0.1 });
    if (sentinelRef.current) observer.observe(sentinelRef.current);
    return () => observer.disconnect();
  }, [handleObserver]);

  return (
    <div className={styles.catalogPage}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h1 className={styles.title}>Новинки 2026</h1>
          <p className={styles.subtitle}>Дорамы 2026 года</p>
        </div>

        <div className={styles.resultsInfo}>
          <p>Найдено: <span className={styles.count}>{totalCount}</span> дорам</p>
        </div>

        <div className={styles.dramasGrid}>
          {allDramas.length === 0
            ? Array.from({ length: 24 }, (_, i) => <SkeletonCard key={i} />)
            : allDramas.map(drama => (
                <DoramaCard
                  key={drama.id}
                  id={drama.id}
                  slug={drama.slug}
                  slug_id={drama.slug_id}
                  image={`https://doramahype.ru/uploads/posters/${drama.poster_url}`}
                  title={drama.title}
                  rating={drama.imdb_rating}
                  year={drama.year}
                  genres={drama.genres ?? []}
                  status={drama.drama_status}
                />
              ))
          }
        </div>

        <div ref={sentinelRef} className={styles.sentinel} />

        {isFetching && allDramas.length > 0 && (
          <div className={styles.loadingMore}>
            <div className={styles.spinner} />
          </div>
        )}
      </div>
    </div>
  );
};

export default New;
